import React from "react";
import { useTranslation } from "react-i18next";
import { SlidersHorizontal } from "lucide-react";
import LegalPage from "@/components/LegalPage";
import { Button } from "@/components/ui/button";
import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { openCookiePreferences } from "@/components/CookieConsent";

export default function CookiePolicy() {
  const { t } = useTranslation();
  const headers = t("cookies_page.table.headers", { returnObjects: true }) || [];
  const rows = t("cookies_page.table.rows", { returnObjects: true }) || [];

  return (
    <LegalPage namespace="cookies_page" testId="cookie-policy-page">
      <div className="mt-12 overflow-x-auto rounded-xl border border-border bg-card">
        <Table data-testid="cookie-policy-table">
          <TableCaption className="px-4 pb-4 text-xs">
            {t("cookies_page.table.caption")}
          </TableCaption>
          <TableHeader>
            <TableRow>
              {headers.map((header) => (
                <TableHead
                  key={header}
                  className="font-data text-[10px] uppercase tracking-[0.12em]"
                >
                  {header}
                </TableHead>
              ))}
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map((row, rowIndex) => (
              <TableRow key={row[0]} data-testid={`cookie-policy-row-${rowIndex}`}>
                {row.map((cell, cellIndex) => (
                  <TableCell
                    key={`${row[0]}-${cellIndex}`}
                    className={`text-xs leading-relaxed ${
                      cellIndex === 0 ? "font-medium text-foreground" : "text-muted-foreground"
                    } ${cellIndex === 1 ? "font-data" : ""}`}
                  >
                    {cell}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>

      <Button
        type="button"
        onClick={openCookiePreferences}
        className="mt-8 h-12 rounded-lg px-6 text-sm"
        data-testid="cookie-policy-manage-button"
      >
        <SlidersHorizontal className="mr-2 h-4 w-4" />
        {t("cookies_page.manage_cta")}
      </Button>
    </LegalPage>
  );
}
